import React from "react";
import classnames from "classnames";
import "./Match.css";
import ChevronRightIcon from "./chevron-right";
import { getCompetitionFlag, lookupFlag } from "./countryFlag";

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const yy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${dd}-${mm}-${yy}`;
};

function Match({ match, opened, onClick }) {
  const containerClasses = classnames("match-container", {
    "match-container--opened": opened === match.id,
  });
  const competitionFlag = getCompetitionFlag(match.competition && match.competition.name);
  const titleParts = match.title ? match.title.split(" - ") : [];
  const teamFlagA = titleParts[0] ? lookupFlag(titleParts[0]) : null;
  const teamFlagB = titleParts[1] ? lookupFlag(titleParts[1]) : null;
  const isInternational = teamFlagA && teamFlagB;

  return (
    <div className={containerClasses}>
      <div onClick={onClick(match.id)} className="match-header">
        <span className="match-date">{formatDate(match.date)}</span>
        <span className="match-title">
          {isInternational ? (
            <>
              <span className="match-flag">{teamFlagA}</span>
              {titleParts[0]}
              <span className="match-title-sep"> - </span>
              <span className="match-flag">{teamFlagB}</span>
              {titleParts[1]}
            </>
          ) : (
            <>
              {competitionFlag && <span className="match-flag">{competitionFlag}</span>}
              {match.title}
            </>
          )}
        </span>
        <ChevronRightIcon className="match-open-btn" />
      </div>
      {opened === match.id && (
        <div className="match-embed" dangerouslySetInnerHTML={{ __html: match.embed }}></div>
      )}
    </div>
  );
}

export default Match;
